
import Navbar from './Navbar';
import HeaderHome from './HeaderHome';
import MainHome from './MainHome';
import ProductsHome from './ProductsHome';
import Footer from './Footer';
import { CartProvider } from 'react-use-cart';

function AllHome() {
  return (
    <CartProvider>
        <Navbar/>
        <HeaderHome/>
        <MainHome/>
        <ProductsHome/>
        <Footer/>
    </CartProvider>
  )
}

export default AllHome;